import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../Core/Config/services/config.service';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { NeptuneApi } from '../genericApi/neptune.api';

@Injectable()
export class ImagesApi {

    constructor(
        private neptuneApi: NeptuneApi,
        private configurationService: ConfigService
    ) {}

    /**
     * Save an image
     *
     * @param queryString  Base64 encoded image data
     */
    public performSaveImage(queryString: string): Observable<string> {
        const body = {
            data: queryString
        };

        return this.neptuneApi.api<string>(
            '/images',
            body,
            HttpVerbsEnum.POST,
            {},
            'text'
        );
    }

    /**
     * Returns the fully-qualified URL to use to view the image associated to the specified image id
     *
     * @param imageId
     */
    public getUrl(imageId: string): string {
        return `${this.configurationService.getConfig().apiUrl}/images/${imageId}`;
    }
}
